module.exports = "<footer>\r\n\t<div class=\"footer-container\">\r\n\t\t<img src=\"https://www.bumblebeestudio.net/smartees/wp-content/uploads/2017/11/EU_flag.png\"/>\r\n\t\t<p>This project has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement No. 761496.</p>\r\n\t</div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/footer-home/footer-home.component.html
// module id = ./Frontend/src/app/components/footer-home/footer-home.component.html
// module chunks = main